import defaultAPIClient, { getAPIClient } from "./Client";
import {
  generateCurlCommand,
  saveLastFiveApicalls,
} from "../utils/captureCallsUtils";
import { getAuthToken, redirectToLoginPage } from "../api/login-service";
import {
  getUseradditionaldetails,
  getUserInfo,
  isNotEmptyOrNull,
} from "../utils/common-utils";

import axios from "axios";
import { ERROR_MESAGES, getCookie } from "../utils/TutorConstants";
import { StorageService } from "../utils/StorageUtils";
import { createStandaloneToast } from "@chakra-ui/react";
import { setSentryUser, setSentryExtras } from "../utils/sentry";

import * as Sentry from "@sentry/remix";

const { toast } = createStandaloneToast();

const STATES = {
  CALL_API: "call_api",
  CALL_REFRESH_TOKEN: "call_refresh_token",
  API_SUCCESS: "api_success",
  EXCEPTION_ERROR: "exception_error",
};

let prePrevState = null;
let prevState = null;
let currState = null;
let nextState = STATES.EXCEPTION_ERROR;

let refreshTokenCallCount = 0;

async function handleStateMachine(state, params, saveAPIObject) {
  prePrevState = prevState;
  prevState = currState;
  currState = state;

  // console.log("PRE-PREV STATE", prePrevState);
  // console.log("PREV STATE", prevState, params?.url);
  // console.log("CURR STATE", currState);

  switch (state) {
    case STATES.CALL_API:
      return await handleApiCall(params, saveAPIObject);
    case STATES.CALL_REFRESH_TOKEN:
      return await handleRefreshToken(params);
    case STATES.API_SUCCESS:
      return handleSuccess(params);
    case STATES.EXCEPTION_ERROR:
      return handleExceptionError(params);
    default:
      throw new Error("Unknown state: ${state}");
  }
}
function APIErrorObject(response, errorMessage) {
  return {
    success: false,
    errorMessage: response?.errors || errorMessage,
    statusCode: response?.statusCode,
    message: response?.message || "",
    sessionData: response?.sessionData || "",
  };
}

async function handleApiCall(params, saveAPIObject) {
  try {
    if (params?.url === "/global-auth/v1/student/refresh-token") {
      refreshTokenCallCount += 1;
    }
    const start = new Date();
    const response = await params?.client.request({
      url: `${window.ENV.REACT_APP_AUTH_URL}${params?.url}`,
      method: params?.method,
      data: params?.body,
      ...params.options,
    });

    const timeTaken = new Date() - start;
    saveAPIObject.timeTaken = timeTaken;
    saveLastFiveApicalls(saveAPIObject);

    let result = await handleAPIResponse(response, params);
    nextState = result?.nextState;
    params = result?.params;
  } catch (error) {
    if (
      params?.url === "/global-auth/v1/student/refresh-token" &&
      refreshTokenCallCount > 0
    ) {
      redirectToLoginPage();
      return;
    }
    console.log("error", error);
    nextState = STATES.EXCEPTION_ERROR;
    params = { ...params, error };
  }

  return nextState ? await handleStateMachine(nextState, params) : null;
}

async function handleAPIResponse(response, params) {
  let userinfo = await getUseradditionaldetails();
  if (userinfo?.studentId) {
    setSentryUser(userinfo);
    // console.log("response",response);
    // console.log("params:",params);
    setSentryExtras({
      response_status: response.status,
      params_url: params.url,
    });
  }

  if (response?.status >= 200 && response?.status < 300) {
    nextState = STATES.API_SUCCESS;
    params = response;
    return { nextState, params };
  } else {
    nextState = STATES.EXCEPTION_ERROR;
  }

  return { nextState, params };
}

async function handleRefreshToken(params) {
  let mainparams = params;
  const refreshEndpoint = "/global-auth/v1/student/refresh-token";

  //let authToken = await getAuthToken(true);

  let userInfo = await getUserInfo();

  defaultAPIClient.defaults.headers.common["Authorization"] =
    userInfo?.accessToken;
  defaultAPIClient.defaults.headers.common["x-user-id"] = userInfo?.userId;
  defaultAPIClient.defaults.headers.common["refreshtoken"] =
    userInfo?.refreshToken;

  try {
    const response = await defaultAPIClient.get(
      `${window.ENV.REACT_APP_AUTH_URL}${refreshEndpoint}`
    );
    // console.log("RESPONSE REFRESH TOKEN", response);

    userInfo.accessToken = response?.data?.data?.idToken;
    // console.log("ACCESS TOKEN NEW", userInfo?.accessToken);
    StorageService.setItem("user_details", JSON.stringify(userInfo));
    StorageService.setItem("authToken", userInfo?.accessToken);

    //nextState = STATES.CALL_API;
    delete defaultAPIClient.defaults.headers.common["refreshtoken"];
    params = { ...mainparams, client: defaultAPIClient };

    return await callApi(
      params?.url,
      params?.method,
      params?.body,
      params?.option
    );
  } catch (error) {
    console.log("Inside Refresh Exception", error);
    redirectToLoginPage();
  }
  return await handleStateMachine(nextState, params);
}

function handleSuccess(response) {
  const { data } = response;
  return {
    success: true,
    data,
  };
}

async function handleExceptionError(params) {
  let userinfo = await getUseradditionaldetails();
  Sentry.setUser({
    student_id: userinfo?.studentId,
    Student_firstName: userinfo?.firstName,
    Student_lastName: userinfo?.lastName,
    School_id: userinfo?.schoolId,
    loginuserid: userinfo?.loginUserId,
  });

  let error = params?.error;
  if (axios.isAxiosError(error)) {
    if (error?.message === "Network Error") {
      console.log("Network Error", error);
      // toast({
      //   title: "Network Error",
      //   description: "Please check your internet connection.",
      //   status: "error",
      //   duration: 5000,
      //   isClosable: true,
      //   position: "top",
      //   containerStyle: {
      //     color: "#fff",
      //   },
      // });
      return {
        success: false,
        errorMessage: "Network Error",
      };
    }

    if (error?.response) {
      console.log("ERROR");
      const { status, data } = error.response;

      if (status === 503 || status === 504) {
        toast({
          title: `Error ${status}`,
          description:
            status === 503
              ? "The server is temporarily unavailable. Please try again shortly. If the problem persists, please contact us."
              : "This page is taking too long to load. Please try refreshing. If the problem persists, please contact us.",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top",
          containerStyle: {
            color: "#fff",
          },
        });
      }

      switch (status) {
        case 401:
          if (params?.url === "/authentication/auth/v2/reset-password") {
            return {
              success: false,
              errorMessage: isNotEmptyOrNull(data?.data)
                ? data?.data
                : isNotEmptyOrNull(data?.error?.message)
                ? data?.error?.message
                : isNotEmptyOrNull(data?.message)
                ? data?.message
                : "",
              statusCode: status,
              sessionData: data?.session,
            };
          } else if (params?.url === "/authentication/auth/verify") {
            return {
              success: false,
              errorMessage: isNotEmptyOrNull(data?.data)
                ? data?.data
                : isNotEmptyOrNull(data?.error?.message)
                ? data?.error?.message
                : isNotEmptyOrNull(data?.message)
                ? data?.message
                : "",
              statusCode: status,
              sessionData: data?.session,
            };
          } else if (prePrevState === STATES.CALL_REFRESH_TOKEN) {
            nextState = STATES.EXCEPTION_ERROR;
            params = new Error("Token refresh failed or is invalid");
            return { nextState, params };
          }
          const { error, ...newParams } = params;

          nextState = STATES.CALL_REFRESH_TOKEN;
          return handleStateMachine(nextState, newParams);
        default:
          return {
            success: false,
            errorMessage: isNotEmptyOrNull(data?.data)
              ? data?.data
              : isNotEmptyOrNull(data?.error?.message)
              ? data?.error?.message
              : isNotEmptyOrNull(data?.message)
              ? data?.message
              : "",
            statusCode: status,
            sessionData: data?.session,
          };
      }
    }
  }
  return {
    success: false,
    errorMessage: error?.message,
  };
}

async function callApi(url, method, body, headers, options) {
  let client = defaultAPIClient;
  let userInfo = await getUserInfo();

  if (url === "/global-auth/v1/student/refresh-token") {
    client.defaults.headers["Authorization"] =
      userInfo?.accessToken ?? userInfo?.idToken;
    client.defaults.headers.common["refreshtoken"] = userInfo?.refreshToken;
  }
  if (isNotEmptyOrNull(userInfo?.userId)) {
    client.defaults.headers["x-user-id"] =
      userInfo?.userId || userInfo?.studentId;
  } else {
    console.log("Call Api cleared");
  }
  if (url !== "/global-auth/v1/student/refresh-token") {
    let authToken = await getAuthToken();
    client.defaults.headers["Authorization"] = authToken;
    delete client.defaults.headers.common["refreshtoken"];
  }
  // if (isNotEmptyOrNull(getCookie("StudentRef"))) {
  client.defaults.headers["referrer_url"] =
    getCookie("StudentRef") || "direct_access";
  // }
  if (isNotEmptyOrNull(getCookie("fingerprint"))) {
    client.defaults.headers["browser-fingerprint"] = getCookie("fingerprint");
  }
  if (isNotEmptyOrNull(headers)) {
    client.defaults.headers = { ...client.defaults.headers, ...headers };
  } else {
    delete client.defaults.headers["x-chat-id"];
    delete client.defaults.headers["x-chat-index"];
  }

  const requestConfig = {
    method: method, // Replace with the HTTP method you need
    url: `${window.ENV.REACT_APP_AUTH_URL}` + url, // Replace with your specific endpoint
    headers: client.defaults.headers,
  };
  if (isNotEmptyOrNull(body)) {
    requestConfig.data = body;
  }
  const saveAPIObject = {};
  saveAPIObject.curlCommand = generateCurlCommand(requestConfig);

  // Start the state machine at the CALL_API state
  nextState = STATES.CALL_API;
  let params = { url, method, body, options, client };

  return await handleStateMachine(nextState, params, saveAPIObject);
}

export default {
  get: (url, body, headers, options) =>
    callApi(url, "get", { params: body }, headers, options),
  post: (url, body, headers, options) =>
    callApi(url, "post", body, headers, options),
  put: (url, body, headers, options) =>
    callApi(url, "put", body, headers, options),
  delete: (url, body, headers, options) =>
    callApi(url, "delete", body, headers, options),
  patch: (url, body, headers, options) =>
    callApi(url, "patch", body, headers, options),
};
